import { FC, useEffect, useState } from 'react';

import { CheckCircle, Warning } from '@mui/icons-material';

import { useLocation } from 'react-router-dom';

import './alert.scss';

const Alert: FC = () => {
  const location = useLocation();
  const [message, setMessage] = useState(location.state?.message);

  useEffect(() => {
    setTimeout(() => setMessage(undefined), 5000);
  }, [setMessage]);

  if (message instanceof Error) {
    return (
      <div id="alert" className="d-flex align-items-center px-3 error" onClick={() => setMessage(undefined)}>
        <div>
          <Warning fontSize="large" color="error" />
        </div>
        <div className="flex-fill p-3">{message.message}</div>
      </div>
    );
  } else if (message) {
    return (
      <div id="alert" className="d-flex align-items-center px-3 success" onClick={() => setMessage(undefined)}>
        <div>
          <CheckCircle fontSize="large" color="success" />
        </div>
        <div className="flex-fill p-3">{message}</div>
      </div>
    );
  } else {
    return null;
  }
};

export default Alert;
